import { render } from "./SalesHistoricSearch.vue?vue&type=template&id=326b6d8a&scoped=true"
import script from "./SalesHistoricSearch.vue?vue&type=script&lang=js"
export * from "./SalesHistoricSearch.vue?vue&type=script&lang=js"

import "./SalesHistoricSearch.vue?vue&type=style&index=0&id=326b6d8a&lang=css"
import "./SalesHistoricSearch.vue?vue&type=style&index=1&id=326b6d8a&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326b6d8a"]])

export default __exports__